export default "__VITE_PUBLIC_ASSET__288cf5f8__"